import { Outlet, useLocation } from "react-router-dom";
import { usePageContext } from "~/contexts/page-context";
import { AdminSidebar } from "./AdminSidebar";

// Declared once for the whole section rather than per page: which admin screen
// is open says little the agent can act on, and naming each one would put a map
// of routes back in the app.
export const AdminLayout = () => {
  usePageContext({ page: "admin" });
  const { pathname } = useLocation();

  return (
    <div className="flex h-full overflow-hidden">
      <AdminSidebar />
      {/* Keyed so each route gets a fresh scroll container, which starts at the top;
            the app wrapper that resets on navigation is not what scrolls here. */}
      <div key={pathname} className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};
